import { Box } from '@chakra-ui/react';
import Highlight from '@components/features/Highlight';
import Body1 from '@components/typography/Body1';
import moneyBag from '@public/assets/icons/primary/desktop/money-orange.svg';
import pencil from '@public/assets/icons/primary/desktop/pencil.svg';
import rx from '@public/assets/icons/primary/desktop/rx.svg';
import time from '@public/assets/icons/primary/desktop/time.svg';
import BaseACABillOfRights from '../BaseACABillOfRights';

const rightsData = [
  {
    header: "You deserve a broker who isn't influenced by commission.",
    iconSrc: moneyBag,
    iconAlt: 'Savings Icon',
    renderDescription: () => (
      <Body1>
        You should be on the right health insurance plan for your needs, regardless of how much it ends up paying your
        broker.
      </Body1>
    ),
  },
  {
    header: 'You deserve proof that all your doctors and drugs are covered.',
    iconSrc: rx,
    iconAlt: 'Prescriptions Icon',
    highlights: [
      {
        query: 'Platinum [+]',
        tooltip:
          "Platinum plans are the highest tier of insurance policies offered through the ACA marketplaces, featuring the highest monthly premiums but the lowest out-of-pocket costs when accessing healthcare services. These plans are designed to cover approximately 90% of an individual's healthcare costs, making them a good option for those who expect to need frequent medical care.",
      },
      {
        query: 'Catastrophic [+]',
        tooltip:
          'Catastrophic health plans are designed to provide an emergency safety net for individuals under 30 or those with a hardship exemption. These plans typically have low monthly premiums but very high deductibles, offering coverage for worst-case scenarios and protecting against the financial burden of major health crises.',
      },
    ],
    renderDescription: () => (
      <Box display="inline" sx={{ ' *': { display: 'inline' } }}>
        <Highlight
          text="Whether you’re signing up for a Catastrophic [+] or Platinum [+] Plan, your advisor should check to see if it’s all covered (unfortunately, many companies make empty promises about this)."
          queries={[
            {
              key: 'Platinum [+]',
              description:
                "Platinum plans are the highest tier of insurance policies offered through the ACA marketplaces, featuring the highest monthly premiums but the lowest out-of-pocket costs when accessing healthcare services. These plans are designed to cover approximately 90% of an individual's healthcare costs, making them a good option for those who expect to need frequent medical care.",
            },
            {
              key: 'Catastrophic [+]',
              description:
                'Catastrophic health plans are designed to provide an emergency safety net for individuals under 30 or those with a hardship exemption. These plans typically have low monthly premiums but very high deductibles, offering coverage for worst-case scenarios and protecting against the financial burden of major health crises.',
            },
          ]}
          renderText={(text) => <Body1>{text}</Body1>}
        />
      </Box>
    ),
  },
  {
    header: 'You deserve to take your time choosing the right plan.',
    iconSrc: time,
    iconAlt: 'Time Icon',
    renderDescription: () => (
      <Body1>
        We don’t mean to be dramatic, but selecting your health insurance plan is a life-changing decision that
        determines your healthcare for the next year.
      </Body1>
    ),
  },
  {
    header: 'You deserve to understand the pros AND cons of your plan.',
    iconSrc: pencil,
    iconAlt: 'Pencil Icon',
    renderDescription: () => (
      <Body1>Trust us, there are always both. For example, where there are savings, there are often trade offs.</Body1>
    ),
  },
];

const BillOfRights = () => <BaseACABillOfRights rightsData={rightsData} />;

export default BillOfRights;
